<template>
    <!-- 材料加工 -->
    <div>
        <contentIndex :initInfo="info"></contentIndex>
    </div>
</template>
<script>
import contentIndex from "./index.vue"
export default {
    components: {
        contentIndex
    },
    data() {
        return {
            info: {
                type: 4,
                testTypeList: [
                    { dictLabel: "全部", dictValue: '' },
                    { dictLabel: "电镜制样", dictValue: '电镜制样'},
                    { dictLabel: "材料加工", dictValue: '材料加工' },
                    { dictLabel: "加工成型", dictValue: '加工成型' },
                    { dictLabel: "热处理", dictValue: '热处理' },
                    { dictLabel: "切割成型", dictValue: '切割成型' },
                    { dictLabel: "真空封管", dictValue: '真空封管' },
                    { dictLabel: "球磨处理", dictValue: '球磨处理' }
                ],
            }
        }
    }
}
</script>